export const REFRESH_MSG = 'Please try refreshing the application. ';
export const PROBLEMS_MSG = 'There may be unexpected errors if you continue. ';
export const CONTACT_MSG =
  'If the error persists, please expand "Error Details" below and send a screen shot to Now Book It technical support. ';
